import { useQuery, useMutation, useQueryClient } from '@tanstack/react-query'
import { courierApi } from '@/services/api'
import type { Availability } from '@/types'

export function useAvailability() {
  return useQuery<Availability>({
    queryKey: ['availability'],
    queryFn: () => courierApi.getAvailability(),
  })
}

export function useUpdateAvailability() {
  const queryClient = useQueryClient()

  return useMutation({
    mutationFn: ({ isOnline, zone }: { isOnline: boolean; zone?: string }) =>
      courierApi.updateAvailability(isOnline, zone),
    onMutate: async ({ isOnline }) => {
      // Optimistic update
      await queryClient.cancelQueries({ queryKey: ['availability'] })
      const previous = queryClient.getQueryData<Availability>(['availability'])
      
      queryClient.setQueryData<Availability>(['availability'], (old) => ({
        ...old!,
        isOnline,
      }))

      return { previous }
    },
    onError: (_err, _variables, context) => {
      // Rollback on error
      if (context?.previous) {
        queryClient.setQueryData(['availability'], context.previous)
      }
    },
    onSettled: () => {
      queryClient.invalidateQueries({ queryKey: ['availability'] })
    },
  })
}
